"use client"
import { RefObject, useEffect, useRef, useState } from 'react';

/**
 * register reset **logic** for an input/select components
 */
export default function useFormItemReset<T extends HTMLInputElement | HTMLSelectElement | null>(ref: RefObject<T>, resetLogic: () => void) {
    useEffect(() => {
        if (!ref.current)
            return;

        const form = ref.current.form
        if (!form) return

        const resetHandler = (event: Event) => {
            if (event.target === form) {
                resetLogic();
            }
        }
        document.addEventListener('reset', resetHandler)
        return () => document.removeEventListener('reset', resetHandler)
    }, [ref, resetLogic])
}

/**
 * register reset **values** for an input/select components
 * 
 * NOTE: using key to completely reset
 * ### SHOULD NOT BE USED FOR MANAGED VALUE COMPONENTS
 */
export function useFormItemReset_Key<T extends HTMLInputElement | HTMLSelectElement | null>(ref: RefObject<T>) {
    const [key, setKey] = useState(Math.random());
    useFormItemReset(ref, async () => {
        await setKey(Math.random())
    })
    return key
}

export function useFormItemRef_byName<T>(name?: string) {
    const ref = useRef<T>(null)
    useEffect(() => {
        if (!name)
            return;
        ref.current = document.getElementsByName(name)[0] as T
    });
    return ref;
}